import React from 'react';
import cn from 'classnames';

import Tooltip from 'Components/Admin/Tooltip';
import UserSVG from 'Components/Admin/assets/UserSVG';
import OrderSVG from 'Components/Admin/assets/OrderSVG';
import DocsSVG from 'Components/Admin/assets/DocsSVG';
import CalendarSVG from 'Components/Admin/assets/CalendarSVG';
import { isDateOlderThanMonth } from 'Components/Admin/utils';

const ProjectInfo = ({ assignedEmployeesCount, ordersCount, invoicesCount, lastInvoiced }) => {
  const projectInfos = [
    {
      title: 'Assigned',
      data: assignedEmployeesCount,
      icon: <UserSVG />,
      isClickable: true,
    },
    {
      title: 'Orders',
      data: ordersCount,
      icon: <OrderSVG />,
      isClickable: true,
    },
    {
      title: 'Invoices',
      data: invoicesCount,
      icon: <DocsSVG />,
      isClickable: true,
    },
    {
      title: 'Last invoiced',
      data: lastInvoiced,
      icon: <CalendarSVG />,
      isCalendar: true,
    },
  ];

  return (
    <div className="table__info-cell">
      {projectInfos.map(({ data, title, icon, isCalendar, isClickable }) => {
        const invoicedInPrev = isCalendar && isDateOlderThanMonth(data);

        if (data) {
          return (
            <Tooltip direction="top" header={title} key={title}>
              <span
                className={cn(
                  `table__info-box`,
                  { 'green-box': invoicedInPrev && isCalendar },
                  { 'table__info-box_clickable': isClickable }
                )}
              >
                {icon}
                {data}
              </span>
            </Tooltip>
          );
        }

        return null;
      })}
    </div>
  );
};

export default ProjectInfo;
